import React from 'react';

import './LabelValueStatisticsWrapper.scss';

interface Props {
  children: any;
}

export const LabelValueStatisticsWrapper: React.FC<Props> = ({ children }) => {
  return <div className="label-value-statistics-wrapper">{children}</div>;
};
